<template>
  <div class="order">
    <img src="@/assets/images/survey/collect/dingdan.png" />
    <div class="order_number">订单号：{{survey.orders.id}}</div>
    <div class="order_tip">{{text}}</div>
  </div>
</template>

<script>
export default {
  props: {
    survey: {
      type: Object
    }
  },
  data() {
    return {};
  },
  computed: {
    text() {
      if (this.ispay) {
        return "已支付";
      } else {
        return "我们将随后有业务人员联系您安排问卷加速收集相关事宜，请注意接听电话。";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.order {
  width: 450px;
  margin: calc((100vh - 600px) / 2) auto 0;

  img {
    height: 230px;
    margin-left: -40px;
  }

  .order_number {
    font-size: 30px;
  }

  .order_tip {
    margin: 25px auto 0;
    font-size: 16px;
    width: 350px;
  }
}
</style>
